import { useCallback, useMemo } from "react";
import { useRouteLoaderData, useSubmit } from "react-router";
import type { loader as rootLoader } from "~/root";

type RootLoaderData = Awaited<ReturnType<typeof rootLoader>>;

export interface AuthState {
  isLoggedIn: boolean;
  userEmail: string;
  isAdmin: boolean;
  isGuest: boolean;
  logout: () => void;
}

export function useAuth(): AuthState {
  const data = useRouteLoaderData("root") as RootLoaderData | undefined;
  const submit = useSubmit();

  const logout = useCallback(() => {
    submit(null, { method: "post", action: "/api/auth/logout" });
  }, [submit]);

  const isLoggedIn = data?.isLoggedIn ?? false;
  const userEmail = data?.userEmail ?? "";
  const isAdmin = data?.isAdmin ?? false;
  const isGuest = data?.isGuest ?? false;

  // R3: stable return object to avoid unnecessary re-renders
  return useMemo(
    () => ({
      isLoggedIn,
      userEmail,
      isAdmin,
      isGuest,
      logout,
    }),
    [isLoggedIn, userEmail, isAdmin, isGuest, logout]
  );
}
